<template>
  <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 2050; background: #FFF9">
    <div style="left: 50%; top: 50%; transform: translate(-50%, -50%); display: inline-block; position: absolute;">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      <div>{{label}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '加載中...'
    }
  }
}
</script>
